import { NavLink, useNavigate, useParams } from "react-router";
import { ReactNode, useCallback, useState } from "react";
import {
  CalculationListTable,
  CalculationListTableFilters,
  useDefaultRltCalculationListRequest,
} from "@/services/backend/rlt/calculations/components/calculation-list-table";
import t from "@/lang/lang";
import { CreateCalculationDialog } from "@/services/backend/rlt/calculations/components/create-calculation-dialog";
import {
  MilestonePage,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";

export function CalculationIndexRoute() {
  const { processId } = useParams();
  const navigate = useNavigate();

  const [request, setRequest] = useState(
    useDefaultRltCalculationListRequest(processId!),
  );

  const renderRowLink = useCallback(
    (id: string, children: ReactNode) => <NavLink to={id}>{children}</NavLink>,
    [],
  );

  const renderCalculationLink = useCallback(
    (
      calculation: { id: string; processId: string | null },
      children: ReactNode,
    ) =>
      calculation.processId === processId ? (
        <NavLink to={calculation.id}>{children}</NavLink>
      ) : (
        <NavLink
          to={`/processes/rlt/${calculation.processId}/calculations/${calculation.id}`}
        >
          {children}
        </NavLink>
      ),
    [processId],
  );

  return (
    <MilestonePage>
      <MilestonePageHeader>
        <MilestonePageTitle>{t("Kalkulationen")}</MilestonePageTitle>
      </MilestonePageHeader>
      <MilestonePageContent>
        <div className="grid gap-2">
          <div className="flex justify-between">
            <CalculationListTableFilters
              request={request}
              onRequestChange={setRequest}
            />
            <CreateCalculationDialog
              processId={processId!}
              onCreated={(id) => navigate(id)}
              renderCalculationLink={renderCalculationLink}
            />
          </div>
          <CalculationListTable
            request={request}
            onRequestChange={setRequest}
            renderRowLink={renderRowLink}
          />
        </div>
      </MilestonePageContent>
    </MilestonePage>
  );
}
